import React from "react";
import "./CustomInput.scss"
import user from "../../assets/profile-2.svg"
import PhoneInput from 'react-phone-number-input'

const CustomPhoneInput = ({ label, icon, value, onChange, placeholder, required, error, errorText, disable }) => {
    const getICons = () => {
        return user
    }
    return (
        <div className="CustomInput">
            <div className="input-label">
                {required && <span className="input-req">* </span>}
                {label}
            </div>
            <div className={`CustomInput-container ${error ? "error" : disable ? "disable" : ""}`}>
                {icon && <img className="CustomInput-container-icon" alt="" src={getICons()} />}
                <form autoComplete="off">
                    <PhoneInput
                        defaultCountry="GB"
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        className="CustomInput-container-input"
                        disabled={disable ?? false}
                    />
                </form>
            </div>
            {errorText !== "" && < div className="input-error-text">
                {errorText}
            </div>}
        </div>
    )
}
export default CustomPhoneInput 